import { isAndroidWebView, isIOSWebView } from './constants'

const sendEventToiOS = (eventType: string, eventData: unknown) => {
  if (window.webkit?.messageHandlers?.chatAppHandler) {
    window.webkit.messageHandlers.chatAppHandler.postMessage({
      event: eventType,
      data: eventData,
    })
  }
}

const sendEventToAndroid = (eventType: string, eventData: unknown) => {
  if (window.AndroidInterface) {
    window.AndroidInterface.postMessage(
      JSON.stringify({
        event: eventType,
        data: eventData,
      })
    )
  }
}

const sendWebViewEvent = (eventType: string, eventData: unknown) => {
  if (isIOSWebView) {
    sendEventToiOS(eventType, eventData)
  }
  if (isAndroidWebView) {
    sendEventToAndroid(eventType, eventData)
  }
}

export const sendEventAuth = (
  access_token: string | null = null,
  refresh_token: string | null = null
) => {
  const eventData = { access_token, refresh_token }
  sendWebViewEvent('chat_auth', eventData)
}

export const sendEventOpenConversation = () => {
  sendWebViewEvent('chat_open_conversation', null)
}

export const sendEventCloseConversation = () => {
  sendWebViewEvent('chat_close_conversation', null)
}

export const sendEventSwitchToB2C = () => {
  sendWebViewEvent('chat_switch_to_b2c', null)
}

export const sendEventLogout = () => {
  sendWebViewEvent('chat_logout', null)
}
